// extracted by mini-css-extract-plugin
export default {"ProjectLinkItemSpan":"ProjectLinkItem_ProjectLinkItemSpan__Wvsuv","ProjectLinkItemAhref":"ProjectLinkItem_ProjectLinkItemAhref__arJ4m"};